import { SelectedCategory } from '@/features/pos/components/ProductCatalog/parts/CategoryBar/types'

export const getNextSelectedCategory = (
    pressed: SelectedCategory,
    prev?: SelectedCategory
): SelectedCategory => {
    if (!prev || !prev?.id) {
        return { id: pressed.id, subcategoryId: pressed.subcategoryId }
    }

    if (pressed.id === prev.id) {
        if (!pressed.subcategoryId) {
            return { id: undefined, subcategoryId: undefined }
        }

        if (pressed.subcategoryId === prev.subcategoryId) {
            return { id: prev.id, subcategoryId: undefined }
        }
    }

    return { id: pressed.id, subcategoryId: pressed.subcategoryId }
}
